import { ParsedURL } from 'shared/utils/urls';
/**
 * console.log() replacement that doesn't fire in production
 * unless a `debug` variable has been set in the query params.
 */
export var debug = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var debugQueryParam = new ParsedURL().queryParam('debug');
    if (process.env.NODE_ENV === 'production' && !debugQueryParam) {
        return;
    }
    // tslint:disable:no-console
    // eslint-disable-next-line
    console.log.apply(console, args);
};
/**
 * console.log() wrapper to side-step linting.
 */
export var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // tslint:disable:no-console
    // eslint-disable-next-line
    console.log.apply(console, args);
};
export default debug;
